module.exports = __webpack_public_path__ + "static/s4-icons-94b82518a9400d982bd170fc6866f481.png";